module.exports = __webpack_public_path__ + "img/PVP_NorseTechHammerOfThor1_ua.dfa312d7.webp";